import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import { AboutLP } from '@src/components/sco/About';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default function Page() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ScoSiteNavBar />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<Box width="full"><AboutLP /></Box></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}